import {ADD_GENERAL_INFO, ADD_USERS_INFO} from '../actions';

export const addGeneralInfo = (payload) => ({
  type: ADD_GENERAL_INFO,
  payload,
});

export const addUsersInfo = (payload) => ({
  type: ADD_USERS_INFO,
  payload,
});
